import { setClassName } from '@change-corgi/core/error';

import { PageDataError } from '#src/shared/error';

import type { SubscriptionsQuery } from '../contributionsPageData.graphql';

type SubscriptionConfig = {
	amountChoices: number[];
	minimumAmount: number;
	maximumAmount: number;
};

type Subscription = NonNullable<NonNullable<NonNullable<SubscriptionsQuery['viewer']>['user']>['subscriptions'][0]> & {
	config: SubscriptionConfig;
	unsavedAmount: number;
};

/** @knip-ignore */
export type ContributionsPageFeatureConfigs = SubscriptionsQuery['featureConfigs'];

export type ContributionsPageData = {
	subscription: Subscription;
	featureConfigs: ContributionsPageFeatureConfigs;
	countryCode: string;
	currency: string;
	currencyExchangeRate: number | undefined;
};

export type ContributionsPageDataFromApi = {
	subscription: NonNullable<NonNullable<NonNullable<SubscriptionsQuery['viewer']>['user']>['subscriptions'][0]>;
	country: NonNullable<NonNullable<SubscriptionsQuery['viewer']>['user']>['country'];
};

export type ContributionsPageDataErrorCode = 'contributions_page_data_not_found';
export class ContributionsPageDataError extends PageDataError<ContributionsPageDataErrorCode> {}
setClassName(ContributionsPageDataError, 'ContributionsPageDataError');
